import { BffApiClientMolecule } from "@/app/api-client/store"
import {
  type Currency,
  type CurrencyId,
  UNKNOWN_CURRENCY,
} from "@anaconda/core/price/types"
import { atom, computed } from "@reatom/core"
import { molecule } from "bunshi"
import { getAllCurrenciesQueryParams } from "./all-currencies-query"

export const CurrencyMoleculeReatom = molecule((mol) => {
  const bffApiClient = mol(BffApiClientMolecule)

  // Query params atom for TanStack Query with suspense
  const allCurrenciesQueryParamsAtom = computed(
    () => ({
      ...getAllCurrenciesQueryParams(bffApiClient),
      refetchInterval: 1000 * 60,
    }),
    "allCurrenciesQueryParams",
  )

  // Query params atom for TanStack Query without suspense
  const currenciesWithoutSuspenseQueryParamsAtom = computed(
    () => getAllCurrenciesQueryParams(bffApiClient),
    "currenciesWithoutSuspenseQueryParams",
  )

  // Create a factory function instead of atomFamily
  // This is a regular function (not an atom) that accepts currencies array
  // and returns a lookup function
  const reatomCurrencyById =
    (currencies: Currency[] | undefined) => (currencyId?: CurrencyId) => {
      const result: Currency =
        (currencies ?? []).find(
          (currency) => currency.id.toLowerCase() === currencyId?.toLowerCase(),
        ) ?? UNKNOWN_CURRENCY
      return result
    }

  return {
    allCurrenciesQueryParamsAtom,
    currenciesWithoutSuspenseQueryParamsAtom,
    reatomCurrencyById,
  }
})
